import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { Backdrop, CircularProgress } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Divider from "@material-ui/core/Divider"
//*antd
import Modal from 'antd/es/modal';
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'

const TelematicsServiceDetails = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [serviceDetails, setServiceDetails] = useState(undefined)
    const [serviceRequestId, setServiceRequestId] = useState()
    const [update, setUpdate] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/ServiceDetails/',
            linkLegend: t('telematicsDetail.serviceDetailsSingular'),
            urlParams: [{ key: 'branchOfficeId', value: props.match.params.branchOfficeId }, { key: 'serviceId', value: props.match.params.instalationId }]
        }
        props.navigationActions.add_route(newRoute)
        setServiceRequestId(parseInt(props.match.params.serviceId))
        if (update === false) {
            props.actions.fecth_Installation_Order_Detail(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.installationOrderId, onError, onSuccess)
        } else {
            const serviceDetailLoad = props.installationDetail.installationOrderServicesListDto.filter(function (serviceID) {
                return serviceID.serviceRequestId === serviceRequestId
            })
            setServiceDetails(serviceDetailLoad)
            setOpenBackdrop(false);
        }
        return () => {

        }
    }, [update]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
        setUpdate(true)
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                < br />
                <Container className={classes.generalBorder}>
                    <Grid container item xs={12} spacing={3} >
                        <Grid item xs={12} >
                            <p className={classes.titleForDetails}><b>{t(`telematicsDetail.serviceDetailsSingular`)}</b></p>
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                            {
                                serviceDetails !== undefined
                                    ?
                                    <div>
                                        <Grid item xs={12} >
                                            <p className={classes.subtTitles}><b>{t(`telematicsDetail.serviceInformation`)}</b></p>
                                        </Grid>
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.serviceNumber')}</Typography>
                                                <Typography variant="body2">{serviceRequestId}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.client')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].legalName}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }} >{t('common.creationDate')}</Typography>
                                                <Typography variant="body2" >{serviceDetails[0].createDate}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.service')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].type_service}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.status')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].nameStatusDesc}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid item xs={12} >
                                            <p className={classes.subtTitles}><b>{t(`telematicsDetail.unitInformation`)}</b></p>
                                        </Grid>
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.fleet')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].fleet}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.brand')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].brand}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.year')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].modelYear}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.unit')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].unitNumber}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.model')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].model}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>VIN</Typography>
                                                <Typography variant="body2">{serviceDetails[0].vin}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid item xs={12} >
                                            <p className={classes.subtTitles}><b>{t(`telematicsDetail.contactInfo`)}</b></p>
                                        </Grid>
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.state')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].stateProvince}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.municipality')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].county}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.neighborhood')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].town}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.streetNumber')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].installationAddress}</Typography>
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.startTime')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].startHour}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.endTime')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].endHour}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.phone')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].phone}</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.user')}</Typography>
                                                <Typography variant="body2">{serviceDetails[0].user}</Typography>
                                            </Grid>
                                        </Grid>
                                        <br />
                                    </div>
                                    :
                                    <CircularProgress color="inherit" />
                            }
                        </Grid>
                    </Grid>
                </Container>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    installationDetail: state.TelematicsReducer.installationOrderDetail,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsServiceDetails))
